import { Checkbox } from 'antd'
import { useState } from 'react'
import BaseEditingAttributesCell from './BaseEditingAttributesCell'

EditingBooleanCell = ({ defaultValue, r, c }) ->

  try
    parsedInitialValue = JSON.parse(defaultValue)
  catch
    parsedInitialValue = false

  [value, setValue] = useState(JSON.parse(parsedInitialValue))

  <BaseEditingAttributesCell
    value={value}
    immediatelyWrite={true}
    initialValue={defaultValue}
    r={r}
    c={c}
  >
    <Checkbox
      checked={value}
      onChange={({ target: { checked }}) -> setValue(checked)}
    />
  </BaseEditingAttributesCell>

export default EditingBooleanCell